/* eslint-disable react/no-unescaped-entities */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';
import InputRange, { Range } from 'react-input-range';

import Select2, { DataSelect2 } from 'wdna-select2';
import { UserDO } from 'wdna-components';

import '../../../../../../assets/css/input-range.css';

import { ParameterDO, TypeSensorVariableListDO, VariableDO } from '../../../../configuration/requests';
import { SensorListDO } from '../../../../sensors/requests';
import { ActionListDO, AlarmDO } from '../../../requests';

/**
 * Function to format the label of the alarm
 *
 * @param value to format
 * @returns the formatted label
 */
function formatLabel(value: number): string {
  const formatvalue: string = value
    .toFixed(2)
    .toString()
    .replace('.', ':')
    .replace(':5', ':3')
    .replace('24', '0');

  return formatvalue;
}

/**
 *
 */
function validCharacters(): void {
  // eslint-disable-next-line no-control-regex
  const regexp: RegExp = /[\x00-\x7F]/g;
  const x: HTMLElement | null = document.getElementById('smsBody' || 'voiceBody');
  const array: RegExpMatchArray[] = [...(x as HTMLInputElement).value.matchAll(regexp)];
  (x as HTMLInputElement).value = array.join('');
}

type CustomAlarmDO = Partial<AlarmDO> & {
  checkboxMin?: boolean;
  checkboxMax?: boolean;
}

interface Props {
  formValues: {
    loading?: boolean;

    sensorArray: SensorListDO[];
    typeVariableArray: TypeSensorVariableListDO[];
    variableArray: VariableDO[];
    actionArray: ActionListDO[];

    typeAlarm: boolean;
    typeAction: string;
    previewText?: string;

    defEmailSubject?: ParameterDO;
    defNcxSubject?: ParameterDO;
    defSmsBody?: ParameterDO;
    defNcxBody?: ParameterDO;
    defVoiceBody?: ParameterDO;
    defEmailBody?: ParameterDO;

    timetableL1: Range;
    timetableM1: Range;
    timetableX1: Range;
    timetableJ1: Range;
    timetableV1: Range;
    timetableS1: Range;
    timetableD1: Range;
    timetableL2: Range;
    timetableM2: Range;
    timetableX2: Range;
    timetableJ2: Range;
    timetableV2: Range;
    timetableS2: Range;
    timetableD2: Range;

    data: CustomAlarmDO;
  };
  onChangeStandard: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  onChangeSelect: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onChangeSelectReset: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onChangeCheckbox: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDevice: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onChangeRange: (l: string, v: Range | number) => void;
  onClickRadio: (e: React.MouseEvent<HTMLInputElement>) => void;
  onClickPreview: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onResetRange: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onResetRangeTwo: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onMaxRange: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onMaxRangeTwo: (e?: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
function Form(props: Props): JSX.Element {
  const { sensorArray, typeVariableArray, actionArray } = props.formValues;
  const { typeAction, typeAlarm } = props.formValues;
  const { timetableL1, timetableM1, timetableX1, timetableJ1, timetableV1, timetableS1, timetableD1 } = props.formValues;
  const { timetableL2, timetableM2, timetableX2, timetableJ2, timetableV2, timetableS2, timetableD2 } = props.formValues;
  const { defEmailSubject, defEmailBody, defSmsBody, defVoiceBody, defNcxSubject, defNcxBody } = props.formValues;

  const { data, previewText } = props.formValues;

  const user: UserDO = _.get(window.store.getState(), ['user', 'user']);
  const userIsAdmin: boolean = user.type === 'adm';

  let isEmail: boolean = false;
  let isSms: boolean = false;
  let isVoice: boolean = false;
  let isHardware: boolean = false;

  let messageMaxLength: number = 160;
  let messageBodyName: string = '';
  let messageSubjectDef: string = (defNcxSubject ? defNcxSubject.value : '');
  let messageBodyDef: string = (defNcxBody ? defNcxBody.value : '');
  switch (typeAction.toUpperCase()) {
    case 'SMS':
      isSms = true;
      messageBodyName = 'smsBody';
      messageMaxLength = 160;
      if (typeAlarm) messageBodyDef = defSmsBody?.value || '';
      break;
    case 'VOICE':
      isVoice = true;
      messageBodyName = 'voiceBody';
      messageMaxLength = 160;
      if (typeAlarm) messageBodyDef = defVoiceBody?.value || '';
      break;
    case 'EMAIL':
      isEmail = true;
      messageBodyName = 'mailBody';
      messageMaxLength = 450;
      if (typeAlarm) messageSubjectDef = defEmailSubject?.value || '';
      if (typeAlarm) messageBodyDef = defEmailBody?.value || '';
      break;
    default:
      isHardware = true;
      messageBodyName = 'body';
  }

  return (
    <div>
      <fieldset>
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Device</b>&nbsp;&nbsp;&nbsp;
            </label>
            <Select2
              name="sensor.id"
              id="sensor.id"
              data={sensorArray
                .filter((sens: SensorListDO): boolean => {
                  return userIsAdmin || sens.companyName === user?.extra?.company;
                })
                .map((item: SensorListDO): DataSelect2 => {
                  return {
                    id: item.id,
                    text: `${item.companyName} - ${item.code}: ${item.name}`,
                  };
                })}
              value={data?.sensor?.id || ''}
              options={{
                placeholder: 'Select option',
              }}
              onChange={props.onChangeDevice}
              style={{ width: '80%' }}
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
          <div className="col-3">
            <label className="label">
              <b>Status</b>&nbsp;&nbsp;&nbsp;
            </label>
            <input
              className="inputNew"
              type="checkbox"
              name="active"
              id="active"
              data-handler-type="boolean"
              checked={data.active || false}
              onChange={props.onChangeCheckbox}
            />
            &nbsp;&nbsp;
            <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              Active
            </label>
          </div>
          <div className="col-3" id="alarmType">
            <label className="label">
              <b>Type</b>&nbsp;&nbsp;&nbsp;
            </label>
            <input
              className="inputNew"
              type="radio"
              name="typeAlarm"
              id="typeAlarm"
              data-handler-type="integer"
              checked={typeAlarm || false}
              value="1"
              onClick={props.onClickRadio}
              onChange={(): void => { /* pass */ }}
            />
            &nbsp; &nbsp;
            <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              Variable
            </label>
            &emsp;
            <input
              className="inputNew"
              type="radio"
              name="typeAlarm"
              id="typeAlarmNc"
              data-handler-type="integer"
              checked={!typeAlarm || false}
              value="0"
              onClick={props.onClickRadio}
              onChange={(): void => { /* pass */ }}
            />
            &nbsp; &nbsp;
            <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              Disconnection
            </label>
          </div>
        </div>
        <br />
        <div hidden={!typeAlarm}>
          <div className="row">
            <div className="col-6">
              <label className="label">
                <b>Variable</b>&nbsp;
              </label>
              <Select2
                name="typeSensorVariable.id"
                id="typeSensorVariable.id"
                data={typeVariableArray.map((item: TypeSensorVariableListDO): DataSelect2 => {
                  return { text: `${item.order}: ${item.variableName}`, id: item.id };
                })}
                value={data?.typeSensorVariable?.id || ''}
                options={{
                  placeholder: 'Select option',
                }}
                onChange={props.onChangeSelect}
                style={{ width: '80%' }}
              />
              <label>&nbsp;&nbsp;*</label>
            </div>
            <div className="col-6">
              <label className="label">
                <b>Minutes to exceed before warning</b>&nbsp; &nbsp;&nbsp;
              </label>
              <input
                className="inputNew"
                type="number"
                value={data.minutes || (data.minutes === 0 ? 0 : '')}
                name="minutes"
                id="minutes"
                onChange={props.onChangeStandard}
              />
              &emsp;&emsp;
              <input
                className="inputNew"
                type="checkbox"
                name="accumulate"
                id="accumulate"
                data-handler-type="boolean"
                checked={data.accumulate || false}
                onChange={props.onChangeCheckbox}
              />
              &nbsp;&nbsp;
              <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                Cumulative
              </label>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-2">
              <input
                className="inputNew"
                type="checkbox"
                name="checkboxMin"
                id="checkboxMin"
                checked={data.checkboxMin || false}
                onChange={props.onChangeCheckbox}
              />
              &nbsp; &nbsp;
              <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                Minimum
              </label>
              <br />
              &nbsp; &nbsp; &nbsp; &#8239; &#8239;
              <input
                className="inputNew"
                type="number"
                disabled={!data.checkboxMin}
                value={data.min || (data.min === 0 ? 0 : '')}
                name="min"
                id="min"
                onChange={props.onChangeStandard}
              />
            </div>
            <div className="col-2">
              <input
                className="inputNew"
                type="checkbox"
                name="checkboxMax"
                id="checkboxMax"
                checked={data.checkboxMax || false}
                onChange={props.onChangeCheckbox}
              />
              &nbsp; &nbsp;
              <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                Maximum
              </label>
              <br />
              &nbsp; &nbsp; &nbsp; &nbsp;
              <input
                className="inputNew"
                type="number"
                disabled={!data.checkboxMax}
                value={data.max || (data.max === 0 ? 0 : '')}
                name="max"
                id="max"
                onChange={props.onChangeStandard}
              />
            </div>
            <div className="col-2">
              <label className="label">
                <b>Repeatability time (minutes)</b>&nbsp; &nbsp;&nbsp;
              </label>
              <input
                className="inputNew"
                type="number"
                value={data.repeat || (data.repeat === 0 ? 0 : '')}
                name="repeat"
                id="repeat"
                onChange={props.onChangeStandard}
              />
            </div>
          </div>
        </div>
        <div hidden={typeAlarm}>
          <div className="row" id="divNc">
            <div className="col-6">
              <label className="label">
                <b>Minutes disconnected before warning</b> &nbsp; &nbsp;&nbsp;
              </label>
              <input
                className="inputNew"
                type="number"
                value={data.disconnection || (data.disconnection === 0 ? 0 : '')}
                name="disconnection"
                id="disconnection"
                onChange={props.onChangeStandard}
              />
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="row">
          <div className="col-6">
            <h2>
              <span className="widget-icon" style={{ padding: '4px' }}>
                <i className="fa fa-edit" />
              </span>
              Warning &nbsp;&nbsp;
            </h2>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Action</b>&nbsp; &nbsp;&nbsp;
            </label>
            <Select2
              name="action.id"
              id="action"
              data={actionArray.map((item: ActionListDO): DataSelect2 => {
                return { text: item.name, id: item.id };
              })}
              value={(data.action && data.action.id) || ''}
              options={{
                placeholder: 'Select option',
              }}
              onChange={props.onChangeSelectReset}
              style={{ width: '80%' }}
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
          <div className="col-6" hidden={!isHardware}>
            <label className="label">
              <b>Gateway</b>&nbsp;
            </label>
            <Select2
              name="gatewayId"
              id="gatewayId"
              data={sensorArray.map((item: SensorListDO): DataSelect2 => {
                return { text: `${item.companyId} - ${item.name} (${item.code})`, id: item.id };
              })}
              value={data?.gatewayId || ''}
              options={{
                placeholder: 'Select option',
              }}
              onChange={props.onChangeStandard}
              style={{ width: '80%' }}
            />
            <label>&nbsp;&nbsp;*</label>
          </div>
        </div>
        <br />
        <div hidden={!isHardware}>
          <div className="row">
            <div className="col-6">
              <label className="label">
                <b>Actuation time</b>&nbsp;
              </label>
              <input
                className="inputNew"
                type="number"
                value={data.launch || ''}
                name="launch"
                id="launch"
                onChange={props.onChangeStandard}
              />
            </div>
          </div>
          <br />
        </div>
        <div hidden={!isSms}>
          <div className="row">
            <div className="col-6">
              <label className="label">
                <b>Phone number to receive SMS (separate the different options by ';' max:9)</b>&nbsp; &nbsp;&nbsp;
              </label>
              <input
                className="inputNew"
                type="text"
                value={data.smsTo || ''}
                name="smsTo"
                id="smsTo"
                onChange={props.onChangeStandard}
              />
              <label>&nbsp;&nbsp;*</label>
              &emsp;&emsp;
              <input
                className="inputNew"
                type="checkbox"
                name="msgUnique"
                id="msgUniqueSMS"
                data-handler-type="boolean"
                checked={data.msgUnique || false}
                onChange={props.onChangeCheckbox}
              />
              &nbsp;&nbsp;
              <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                Send only once
              </label>
            </div>
          </div>
          <br />
        </div>
        <div hidden={!isVoice}>
          <div className="row">
            <div className="col-6">
              <label className="label">
                <b>Phone number to receive calls (separate the different options by ';' max:9)</b>&nbsp; &nbsp;&nbsp;
              </label>
              <input
                className="inputNew"
                type="text"
                value={data.voiceTo || ''}
                name="voiceTo"
                id="voiceTo"
                onChange={props.onChangeStandard}
              />
              <label>&nbsp;&nbsp;*</label>
              &emsp;&emsp;
              <input
                className="inputNew"
                type="checkbox"
                name="msgUnique"
                id="msgUniqueVoice"
                data-handler-type="boolean"
                checked={data.msgUnique || false}
                onChange={props.onChangeCheckbox}
              />
              &nbsp;&nbsp;
              <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                Send only once
              </label>
            </div>
          </div>
          <br />
        </div>
        <div hidden={!isEmail}>
          <div className="row">
            <div className="col-6">
              <label className="label">
                <b>Recipient (separate the different options by ';' max:8)</b>&nbsp;
              </label>
              <input
                className="inputNew"
                style={{ width: '40%' }}
                type="text"
                value={data.mailTo || ''}
                name="mailTo"
                id="mailTo"
                size={40}
                onChange={props.onChangeStandard}
              />
              <label>&nbsp;&nbsp;*</label>
              &emsp;&emsp;
              <input
                className="inputNew"
                type="checkbox"
                name="msgUnique"
                id="msgUniqueEmail"
                data-handler-type="boolean"
                checked={data.msgUnique || false}
                onChange={props.onChangeCheckbox}
              />
              &nbsp;&nbsp;
              <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                Send only once
              </label>
            </div>
            <div className="col-6">
              <label className="label">
                <b>Subject</b> &nbsp; &nbsp;&nbsp;
              </label>
              <input
                className="inputNew"
                style={{ width: '80%' }}
                type="text"
                value={data.mailSubject || messageSubjectDef}
                name="mailSubject"
                id="mailSubject"
                size={40}
                onChange={props.onChangeStandard}
              />
            </div>
          </div>
        </div>
        <br />
        <div hidden={isHardware}>
          <div className="row">
            <div className="col-6">
              <label className="label">
                <b>Body</b>
                <br />
                Available characters:{' '}
                {messageMaxLength - ((data[messageBodyName] && data[messageBodyName].length) || messageBodyDef.length)}
                <br />
                Available variables: {'{sensor}, {name}, {description}'}
                {typeAlarm && ', {variable}, {min}, {max}, {unit}, {reading}'}
                &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
              </label>
              <textarea
                className="inputNew"
                style={{ width: '80%' }}
                name={messageBodyName}
                id={messageBodyName}
                rows={5}
                cols={55}
                maxLength={messageMaxLength}
                value={data[messageBodyName] || messageBodyDef}
                onChange={props.onChangeStandard}
                onKeyUp={validCharacters}
              />
            </div>
            <div className="col-6">
              <button
                type="button"
                onClick={props.onClickPreview}
                className="btn btn-default"
                style={{ margin: '10px 0 0 5px', padding: '0 22px', height: '31px' }}
              >
                Preview text
              </button>
              <br /><br />
              <textarea
                className="inputNew"
                style={{ width: '80%' }}
                rows={5}
                cols={55}
                maxLength={160}
                value={previewText || ''}
                readOnly
              />
            </div>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <h2>
              <span className="widget-icon" style={{ padding: '4px' }}>
                <i className="fa fa-edit" />
              </span>
              Scheduling &nbsp;&nbsp;
            </h2>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <button type="button" className="btn btn-default" onClick={(): void => props.onResetRange()}>
                &nbsp;&nbsp; RESET ALL &nbsp;&nbsp;
            </button>
            &nbsp;&nbsp;
            <button type="button" className="btn btn-default" onClick={(): void => props.onMaxRange()}>
                &nbsp;&nbsp; SET ALL &nbsp;&nbsp;
            </button>
          </div>
          <div className="col-6">
            <button type="button" className="btn btn-default" onClick={(): void => props.onResetRangeTwo()}>
                &nbsp;&nbsp; RESET ALL &nbsp;&nbsp;
            </button>
            &nbsp;&nbsp;
            <button type="button" className="btn btn-default" onClick={(): void => props.onMaxRangeTwo()}>
                &nbsp;&nbsp; SET ALL &nbsp;&nbsp;
            </button>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Monday: {formatLabel(timetableL1.min)} - {formatLabel(timetableL1.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableL1"
              value={timetableL1}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableL1', value)}
            />
          </div>
          <div className="col-6" max-width="55%">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Monday: {formatLabel(timetableL2.min)} - {formatLabel(timetableL2.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableL2"
              value={timetableL2}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableL2', value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Tuesday: {formatLabel(timetableM1.min)} - {formatLabel(timetableM1.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableM1"
              value={timetableM1}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableM1', value)}
            />
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Tuesday: {formatLabel(timetableM2.min)} -{' '}
              {formatLabel(timetableM2.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableM2"
              value={timetableM2}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableM2', value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Wednesday: {formatLabel(timetableX1.min)} - {formatLabel(timetableX1.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableX1"
              value={timetableX1}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableX1', value)}
            />
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Wednesday: {formatLabel(timetableX2.min)} - {formatLabel(timetableX2.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableX2"
              value={timetableX2}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableX2', value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Thursday: {formatLabel(timetableJ1.min)} - {formatLabel(timetableJ1.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableJ1"
              value={timetableJ1}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableJ1', value)}
            />
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Thursday: {formatLabel(timetableJ2.min)} - {formatLabel(timetableJ2.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableJ2"
              value={timetableJ2}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableJ2', value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Friday: {formatLabel(timetableV1.min)} - {formatLabel(timetableV1.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableV1"
              value={timetableV1}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableV1', value)}
            />
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Friday: {formatLabel(timetableV2.min)} - {formatLabel(timetableV2.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableV2"
              value={timetableV2}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableV2', value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Saturday: {formatLabel(timetableS1.min)} - {formatLabel(timetableS1.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableS1"
              value={timetableS1}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableS1', value)}
            />
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Saturday: {formatLabel(timetableS2.min)} - {formatLabel(timetableS2.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableS2"
              value={timetableS2}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableS2', value)}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Sunday: {formatLabel(timetableD1.min)} - {formatLabel(timetableD1.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableD1"
              value={timetableD1}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableD1', value)}
            />
          </div>
          <div className="col-6">
            <label className="label">
              &nbsp;&nbsp;&nbsp;&nbsp;Sunday: {formatLabel(timetableD2.min)} - {formatLabel(timetableD2.max)}
            </label>
            <InputRange
              maxValue={24}
              minValue={0}
              step={0.5}
              name="timetableD2"
              value={timetableD2}
              allowSameValues
              formatLabel={formatLabel}
              onChange={(value: Range | number): void => props.onChangeRange('timetableD2', value)}
            />
          </div>
        </div>
      </fieldset>
    </div>
  );
}

export default Form;
